// plugins/vconsole.client.ts
export default defineNuxtPlugin(() => {
  if (import.meta.env.VITE_APP_ENV !== "beta") {
    return;
  }

  const script = document.createElement("script");
  script.src = "//bbstaticcdn.babybus.com/vConsole/3.15.1/vconsole.min.js";
  script.async = true;
  script.onload = () => {
    // @ts-ignore
    new window.VConsole();
  };
  script.onerror = () => {
    console.warn("vConsole 加载失败");
  };
  document.head.appendChild(script);
});
